import React, { useState, useContext } from 'react';

export interface Partner {
  id: string;
  name: string;
}

const initialContext = {
  partnerContext: { id: '', name: '' },
  setPartnerContext: () => null,
};

export interface PartnerContextProps {
  partnerContext: Partner;
  setPartnerContext: (val: Partner) => void;
}

export interface PartnerContextProvider {
  children?: React.ReactNode;
}

export const PartnerContext = React.createContext<PartnerContextProps>(initialContext);

export const usePartnerContext = () => useContext(PartnerContext);

export const PartnerContextProvider = ({ children }: PartnerContextProvider) => {
  const [partnerContext, setPartnerContext] = useState<Partner>(initialContext.partnerContext);

  return (
    <PartnerContext.Provider
      value={{
        partnerContext,
        setPartnerContext,
      }}
    >
      {children}
    </PartnerContext.Provider>
  );
};
